// Initialize your components on DOM Ready.
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.preloadAfterLoad = true
require('lazysizes');
import AOS from 'aos';  
// import Swup from 'swup'; 
// import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupGiaPlugin from '@swup/gia-plugin';
// import SwupScrollPlugin from '@swup/scroll-plugin';
// import JsPlugin from './swup/plugins/JsPlugin'
// import DebugPlugin from '@swup/debug-plugin';
// import transitions from './swup/transitions/transitions'
import loadComponents from 'gia/loadComponents'

import components from './components' 
import Global from './global' 
 
loadComponents(components);
   
  // SWUP
  // const SwupOptions = {
  //   linkSelector:'a[href^="/"]:not([data-no-swup]), a[href^="' + window.location.origin + '"]:not([data-no-swup])',
  //   animateHistoryBrowsing: true,
  //   cache: true,
  //   scroll: false,
  //   plugins: [ 
  //     new JsPlugin(transitions),
  //     new SwupBodyClassPlugin(),
  //     new SwupGiaPlugin({ components }),
  //     new SwupScrollPlugin({animateScroll: false}),
  //     // new DebugPlugin()
  //   ]
  // }
  // const swup = new Swup(SwupOptions); 
  // init();
  // swup.on('contentReplaced', init);
  
 init();

  function init() {
    AOS.init();
    Global.init();
  }
    